import { render, staticRenderFns } from "./ai-distribution-modal.vue?vue&type=template&id=bf500a7a&scoped=true&"
import script from "./ai-distribution-modal.vue?vue&type=script&lang=js&"
export * from "./ai-distribution-modal.vue?vue&type=script&lang=js&"
import style0 from "./ai-distribution-modal.vue?vue&type=style&index=0&id=bf500a7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf500a7a",
  null
  
)

export default component.exports